// Browser compatibility helper for WaterWave component
export const isMobileDevice = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth <= 768
  );
};

export const isWaterWaveSupported = () => {
  // Check if the browser supports required features for WaterWave
  const isSupported =
    typeof window !== "undefined" &&
    window.requestAnimationFrame &&
    window.CanvasRenderingContext2D &&
    !isMobileDevice();

  return isSupported;
};

export const getDeviceType = () => {
  if (isMobileDevice()) {
    return "mobile";
  }
  return "desktop";
};
